import React from "react";
import { Breadcrumbs, Link, Typography } from "@mui/material";
import { BreadCrumbProps } from "../../types/BreadCrumbProps";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

const Breadcrumb: React.FC<BreadCrumbProps> = ({ path = [], onClick }) => (
  <Breadcrumbs
    separator={<NavigateNextIcon style={{ fontSize: "48px" }} />}
    aria-label="breadcrumb"
  >
    {path.map((node, index) => (
      <Link
        key={node.id}
        color={index === path.length - 1 ? "textPrimary" : "inherit"}
        onClick={() => onClick(node)}
        style={{ cursor: "pointer", textDecoration: "none" }}
      >
        <Typography
          sx={{
            fontFamily: "Inter",
            fontWeight: 600,
            fontSize: "2rem",
            lineHeight: "2.4rem",
            color: "#444746",
          }}
        >
          {node.text}
        </Typography>
      </Link>
    ))}
  </Breadcrumbs>
);

export default Breadcrumb;
